import BasePage from '@/found/components/table_page';

export default {
  name: 'financial_statements',
  extends: BasePage,
  data() {
    return {};
  },
  components: {

  },
  async created() {
    await this.getConfigList('financial_statement');
  },
  methods: {

  },
};
